import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import {
  NavLink,
  NavRoleMapping,
  NavRoles
} from "../navigation.models";
import { NavigationService } from "../navigation.service";
import { AlertService } from "../../alert/alert.service";
import { AppService } from "../../../../app.service";
@Component({
  selector: "app-role-mapping",
  templateUrl: "./role-mapping.component.html",
  styleUrls: ["./role-mapping.component.scss"],
})
export class RoleMappingComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public NgxData: any = [];
  public navlinkform: FormGroup;
  public displayedColumns = [
    "title",
    "link",
    "parent",
    "role",
    "action",
  ];
  public DataMap: NavLink[] = [];
  public OrignalData: any[] = [];
  public Navlink: boolean = false;
  dataSource = new MatTableDataSource<any>([]);
  public isEditing: boolean = false;
  subscription: Subscription;
  public ResponseData: NavRoleMapping;
  public DataNavRoles: any[] = [];
  public datan: any[] = [];
  public RolesData: NavRoles[] = [];
  activeInactiveStatus: boolean = true;
  InactiveStatusData: any;
  newDataSource: any[];
  IsEditRole: boolean = false;
  SavedRoles: boolean;
  sourceData: any;
  Source = [
    {
      id: "ERP",
      name: "ERP",
    },
    {
      id: "LCP",
      name: "LCP",
    },
  ];
  resultsLength: number;
  currentPage: number = 1;
  showEdit: boolean = true;
  constructor(
    public fb: FormBuilder,
    public router: Router,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public alertService: AlertService,
    public navservice: NavigationService,
    public commonService: AppService
  ) {
    this.subscription = this.navservice.roleclosesub$.subscribe((val: any) => {
      this.ResponseData = val as NavRoleMapping;
      this.closee();
    });

    this.navlinkform = this.fb.group({
      link: "",
      role: "",
      source: "LCP",
    });
  }

  ngOnInit(): void {
    this.GetAllNavLink();
    this.getroles()
    this.GetAllNavRolesMap();
    //  this.navlinkform.get("source").patchValue("LCP");
  }
  AddnewRoleMap() {
    var data = new NavRoleMapping();
    this.SavedRoles = false;
    data.Isdialog = false;
    this.navservice.sendRoleDataDialog(data);
    this.Navlink = true;
    this.isEditing = true;

    // let dialogRef ;
    // dialogRef.afterClosed().subscribe(data => {
    //
    //   this.isEditing=false;
    //   this.Navlink=false;
    // this.GetAllNavLink();

    // });
  }
  closee() {
    this.isEditing = false;
    this.Navlink = false;
    this.GetAllNavRolesMap();
  }
  public openUserDialog(user: any) {
    let data = new NavRoleMapping();
    this.SavedRoles = true;
    data = user;
    data.Isdialog = false;
    this.Navlink = true;
    this.isEditing = true;
    data.Navlinkmap = [];

    this.datan = this.OrignalData.filter(
      (x) =>
        x.roleId.toUpperCase() == user.roleId.toUpperCase() &&
        x.isDeleted === false
    );

    if (this.datan) {
      for (const element of this.datan) {
        data.Navlinkmap.push(element.navigationAccess[0]);
      }
    }
    this.navservice.sendRoleDataDialog(data);
    this.navservice.sendAllRoleData(this.OrignalData);
  }
  GetAllNavLink() {
    let obj = {};
    this.navservice.listNavLinkData(obj).subscribe((data) => {
      if (data) {
        this.DataMap = data as Array<NavLink>;
      }
    });
  }
  GetAllNavRolesMap(link?: string | undefined, role?: string | undefined, source?: undefined) {
    let obj = {
      Linkname: link ? link : null,
      roles: role ? role : null,
      Source: source ? source : "LCP",
    };

    // this.dataSource.sortBy = direction;
    this.navservice.listNavMapRolesData(obj).subscribe((data) => {
      if (data) {
        this.DataNavRoles = data as Array<NavRoleMapping>;
        this.OrignalData = this.DataNavRoles;
        if (this.activeInactiveStatus == true) {
          this.DataNavRoles = this.DataNavRoles.filter(
            (x) => x.isDeleted == false
          );
          this.newDataSource = this.DataNavRoles;
          this.dataSource = new MatTableDataSource<NavRoleMapping>(
            this.DataNavRoles
          );
          this.dataSource.data.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
            for (const sortColumn of this.sortColumns) {
              const aValue = a[sortColumn.column];
              const bValue = b[sortColumn.column];

              if (sortColumn.direction === "asc") {
                if (aValue < bValue) return -1;
                if (aValue > bValue) return 1;
              } else {
                if (bValue < aValue) return -1;
                if (bValue > aValue) return 1;
              }
            }

            return 0;
          });
          this.resultsLength = this.DataNavRoles.length;
        } else {
          this.InactiveStatusData = this.DataNavRoles.filter(
            (x) => x.isDeleted == true
          );
          this.dataSource = new MatTableDataSource<NavRoleMapping>(
            this.InactiveStatusData
          );
          this.resultsLength = this.InactiveStatusData.length;
        }
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  FilterData(link: string, role: string, source: string) {
    this.DataNavRoles = [];
    if (this.activeInactiveStatus == true) {
      if (source) {
        if (link || role) {
          this.DataNavRoles = this.newDataSource.filter((x) => x.rolename);
          this.DataNavRoles = this.DataNavRoles.filter(
            (x) =>
              x.linkname.toLowerCase().includes(link.toLowerCase()) &&
              x.rolename.toLowerCase().includes(role.toLowerCase()) &&
              x.source != null &&
              x.source.toLowerCase().includes(source.toLowerCase())
          );
        } else {
          this.DataNavRoles = this.newDataSource.filter(
            (x) =>
              x.source != null &&
              x.source.toLowerCase().includes(source.toLowerCase())
          );
        }
      } else if (role == "") {
        this.DataNavRoles = this.newDataSource.filter((x) =>
          x.linkname.toLowerCase().includes(link.toLowerCase())
        );
      } else if (link == "") {
        this.DataNavRoles = this.newDataSource.filter((x) => x.rolename);
        this.DataNavRoles = this.DataNavRoles.filter((x) =>
          x.rolename.toLowerCase().includes(role.toLowerCase())
        );
      } else {
        this.DataNavRoles = this.newDataSource.filter((x) => x.rolename);
        this.DataNavRoles = this.DataNavRoles.filter(
          (x) =>
            x.linkname.toLowerCase().includes(link.toLowerCase()) &&
            x.rolename.toLowerCase().includes(role.toLowerCase())
        );
      }
    } else {
      if (source) {
        if (link || role) {
          this.DataNavRoles = this.newDataSource.filter((x) => x.rolename);
          this.DataNavRoles = this.DataNavRoles.filter(
            (x) =>
              x.linkname.toLowerCase().includes(link.toLowerCase()) &&
              x.rolename.toLowerCase().includes(role.toLowerCase()) &&
              x.source != null &&
              x.source.toLowerCase().includes(source.toLowerCase())
          );
        } else {
          this.DataNavRoles = this.newDataSource.filter(
            (x) =>
              x.source != null &&
              x.source.toLowerCase().includes(source.toLowerCase())
          );
        }
      } else if (role == "") {
        this.DataNavRoles = this.dataSource.data.filter((x: { linkname: string; }) =>
          x.linkname.toLowerCase().includes(link.toLowerCase())
        );
      } else if (link == "") {
        this.DataNavRoles = this.dataSource.data.filter((x: { rolename: any; }) => x.rolename);
        this.DataNavRoles = this.DataNavRoles.filter((x) =>
          x.rolename.toLowerCase().includes(role.toLowerCase())
        );
      } else {
        this.DataNavRoles = this.dataSource.data.filter((x: { rolename: any; }) => x.rolename);
        this.DataNavRoles = this.DataNavRoles.filter(
          (x) =>
            x.linkname.toLowerCase().includes(link.toLowerCase()) &&
            x.rolename.toLowerCase().includes(role.toLowerCase())
        );
      }
    }
    this.dataSource = new MatTableDataSource<NavRoleMapping>(this.DataNavRoles);
  }

  ClearSearch() {
    this.navlinkform.patchValue({ link: "" });
    this.navlinkform.patchValue({ role: "" });
    this.navlinkform.patchValue({ source: "LCP" });
    this.GetAllNavRolesMap();
    this.currentPage = 1;
    this.paginator.pageIndex = 0;
  }

  GetSearchData() {
    this.currentPage = 1;
    let link = this.navlinkform.get("link")?.value;
    let role = this.navlinkform.get("role")?.value;
    let source = this.navlinkform.get("source")?.value;
    this.sourceData = source;
    if (
      link.trim().length > 0 ||     
      source.trim().length > 0
    ) {
      this.GetAllNavRolesMap(link, role, source);
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
    } else {
      return;
    }
  }

  GetInActiveRecords(event: any) {
    if (event.checked == true) {
      this.DataNavRoles = this.OrignalData.filter((x) => x.isDeleted == true);
      this.activeInactiveStatus = false;
      this.showEdit = false;
      this.currentPage = 1;
      this.paginator.pageIndex = 0;
    } else {
      this.GetAllNavRolesMap();
      this.showEdit = true;
      this.activeInactiveStatus = true;
    }
    this.dataSource = new MatTableDataSource<NavRoleMapping>(this.DataNavRoles);
    this.resultsLength = this.DataNavRoles.length;
    this.dataSource.paginator = this.paginator;
  }

  updateinactive(event: any, element: NavRoleMapping) {
    this.navservice.UpdateNavRole(element).subscribe(
      (data) => {
        if (element.IsDeleted) {
          this.GetAllNavRolesMap();
          this.alertService.success(
            "Selected record have been marked as inactive."
          );
        } else {
          let obj = {};
          this.navservice.listNavMapRolesData(obj).subscribe((data) => {
            if (data) {
              this.OrignalData = data as Array<NavRoleMapping>;
              this.DataNavRoles = this.DataNavRoles.filter(
                (x) => x.isDeleted == true
              );
              this.dataSource = new MatTableDataSource<NavRoleMapping>(
                this.DataNavRoles
              );
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
            }
          });
          this.alertService.success(
            "Selected record have been marked as active."
          );
        }
      },
      (error) => {
        this.alertService.error(
          "Navigation Role update Error"
        );
      }
    );
  }



  ngxSetting() { }
  exportAsXLSX() { }

  submitRoles($event: any) {
    this.GetAllNavLink();
    this.GetAllNavRolesMap();
    this.navlinkform.get("source")?.patchValue(this.sourceData);
    this.GetAllNavRolesMap('', '', this.sourceData);
    this.isEditing = false;
    this.Navlink = false;
  }

  ngAfterViewInit() {
    this.paginator.page.subscribe((page: PageEvent) => {
      this.currentPage = page.pageIndex + 1;
    });
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  sortColumns: { column: string; direction: string }[] = [];
  sortTable_(column: string): void {
    const sortColumn = this.sortColumns.find((col) => col.column === column);

    if (sortColumn) {
      sortColumn.direction = sortColumn.direction === "asc" ? "desc" : "asc";
    } else {
      this.sortColumns.push({ column, direction: "asc" });
    }

    this.GetAllNavRolesMap();
  }
  roles: any
  getroles() {
    let url = 'api/Auth/get-roles'
    this.commonService.get<any>(url).subscribe(res => {
      this.roles = res
    })

  }
}
